<div class="download-pdf-container">
  <header class="heading">
    <p>{{ "reports.property_report" | translate }}</p>
    <mat-icon (click)="closePopUp()" class="close pointer">close</mat-icon>
  </header>
      <ng-container *ngIf="loader">
        <div class="download-loader">
          <img src="assets/images/loading.gif" alt="">
        </div>
      </ng-container>
      <ng-container *ngIf="!loader">
        <ng-container *ngFor="let propertyReport of propertyReportData; let last = last">
          <div class="property-report-options">

            <div class="accordion-header d-flex" [ngClass]="{'no-border': last}" (click)="expandAccordion(propertyReport)">

              <div class="d-flex align-items-center pointer     ">
              <span (click)="selectAllReport(propertyReport); $event.stopPropagation()" class="type-mult-check-box" [ngClass]="{'selected_option': propertyReport.display}">
                <svg *ngIf="propertyReport.isDisable" class="check-box check-box-disable"  width="6" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path  d="M6.5 1.125L3.0625 4.5625L1.5 3"stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="!propertyReport.isDisable" [ngClass]="{'check-box-enable' : propertyReport.display}" class="check-box"  width="6" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path  d="M6.5 1.125L3.0625 4.5625L1.5 3"stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <p class="maplayer-box">{{propertyReport.name | translate }}</p>
              </div>
              <ng-container *ngIf="propertyReport.isAccordion">
              <div class="expand-icon pointer">
                <mat-icon *ngIf="!isExpand">expand_more</mat-icon>
                <mat-icon *ngIf="isExpand">expand_less</mat-icon>
              </div>
              </ng-container>
            </div>
            <ng-container  *ngIf="propertyReport.isAccordion && isExpand">
              <div class="accordion-content">
                <div class="d-flex align-items-center pointer" (click)="selectedReport(rentalData)" *ngFor="let rentalData of nearby_Rental_Data">
                  <span class="type-mult-check-box" [ngClass]="{'selected_option' : rentalData.display}">
                    <svg *ngIf="rentalData.display" class="check-box"  width="6" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg"
                      [ngClass]="{'check-box-enable' : rentalData.display}">
                      <path  d="M6.5 1.125L3.0625 4.5625L1.5 3"stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                  <p class="maplayer-box">{{rentalData.name | translate }}</p>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
         <footer>
          <div class="download-button">
            <button [disabled]="loader" (click)="downloadProperty()">{{ "reports.download_report" | translate }}</button>
          </div>
        </footer>
    </ng-container>

</div>
